module.exports = __webpack_public_path__ + "img/Obin.2d50d7cb.png";